import { LockClosedIcon } from '@heroicons/react/24/outline'
import Cookies from 'js-cookie'
import { API_BACKEND_HOST } from 'shared/config'
import { strings } from 'shared/translations'
import { Button } from 'shared/ui'

const url = `${API_BACKEND_HOST}/identities/auth/keycloak`

export function KeycloackAuth() {
  const handleRedirect = () => {
    Cookies.set('originalRequest', window.location.href)
    window.location.assign(url)
  }

  return (
    <Button
      icon={<LockClosedIcon className='mr-3 size-4' />}
      buttonType='PRIMARY'
      customStyles='w-60'
      onClick={handleRedirect}
    >
      {strings.CONTINUE_WITH_SSO}
    </Button>
  )
}
